import { render, staticRenderFns } from "./CoinbaseProExchangeInput.vue?vue&type=template&id=245b5cad&"
import script from "./CoinbaseProExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./CoinbaseProExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports